// src/pages/Categorias.tsx
import React, { useEffect, useState, useCallback } from 'react';
import { useGlobal } from '../context/GlobalContext';
import CategoryTree from '../components/CategoryTree';
import { deleteCategoria } from '../services/categorias';
import { Departamento } from '../types/index';
import ItemForm from '../components/ItemForm';
import DeleteWarning from '../components/DeleteWarning';

const Categorias: React.FC = () => {
  const [categories, setCategories] = useState<Departamento[]>([]);
  const [modalData, setModalData] = useState<any>(null);
  const [modalType, setModalType] = useState<'Agregar' | 'Editar' | 'Eliminar' | null>(null);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const { data, reLoad } = useGlobal();

  const loadCategories = useCallback(async () => {
    if (data?.categoriesTree) {
      setCategories(data.categoriesTree);
    }
  }, [data]);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  const handleClose = () => {
    setModalType(null);
    setModalData(null);
  };

  // Confirmar eliminación
  const handleConfirm = (type: string, item: any) => {
    setModalType('Eliminar');
    setModalData({ type, item });
  };


  // Editar elemento
  const handleEdit = (type: string, item: any) => {
    setModalType('Editar');
    setModalData({ type, item });
  };

  const handleDelete = async () => {
    if (modalData) {
      await deleteCategoria(modalData.type, modalData.item.id)
      handleAlert(`¡${modalData.type} eliminado correctamente!`);
    }
  };


  // Agregar elemento
  const handleAdd = (type: string, parent?: any) => {
    setModalType('Agregar');
    setModalData({ type, parent });
  };

  const handleAlert = (message: string) => {
    setAlertMessage(message);
    reLoad()
    setTimeout(() => setAlertMessage(''), 5000);
  };

  return (
    <div className="categorias-page">
      <h2 className="page-title">Administración de Departamentos</h2>
      {alertMessage && (
        <div className="alert alert-success">{alertMessage}</div>
      )}
      <CategoryTree
        categories={categories}
        onConfirm={handleConfirm}
        onEdit={handleEdit}
        onAdd={handleAdd}
      />
      {modalType && (
        <div className="modal">
          <div className="modal-content">
            {modalType === 'Agregar' && (
              <ItemForm
                level={modalData.type}
                parent={modalData.parent}
                onClose={handleClose}
                onSuccess={handleAlert}
              />
            )}
            {modalType === 'Eliminar' && (
              <DeleteWarning
                itemType={modalData.type}
                itemName={modalData.item.nombre}
                onCancel={handleClose}
                onConfirm={handleDelete}
              />
            )}
            {modalType === 'Editar' && (
              <ItemForm
                level={modalData.type}
                parent={modalData.parent}
                onClose={handleClose}
                onSuccess={handleAlert}
                itemData={modalData.item}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Categorias;